import { useAppDispatch } from "../../../../redux/hooks";

import { ReturningProductsToProviderReportsInterface } from "../../../../redux/interfaces/inventory.interface";
import { getDownloadReturningProductsToProviderRaport } from "../../../../redux/api/reports.api";

import ActionMenu from "../../../../components/actionMenu/ActionMenu";

import {
  TableContextType,
  TableItemType,
} from "../../../../components/tables/tableContext/TableContext";
import { TableItemId } from "../../../../components/tables/TableWidget";

function ReturningProductsReportsActionButton({
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: ReturningProductsToProviderReportsInterface;
  tableContext?: TableContextType;
}) {
  const dispatch = useAppDispatch();

  const handleDownloadNrcd = () => {
    if (!crudData?.nr_raport) return;
    dispatch(
      getDownloadReturningProductsToProviderRaport({
        idRaport: crudData.nr_raport,
        dataPV: crudData.dataPV,
        idReturPv: crudData.id_retur_pv,
      }),
    );
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={`Raport ${crudData?.nr_raport ?? ""}`}
      ariaLabel={`Actiuni pentru raportul ${crudData?.nr_raport ?? ""}`}
      items={[
        {
          id: "print-report",
          label: "Retipareste raport",
          icon: "PRINT",
          kind: "download",
          tooltip: !crudData?.nr_raport
            ? "Raportul nu are un numar disponibil pentru descarcare."
            : "Descarca PDF-ul raportului de produse returnate furnizorului.",
          disabled: !crudData?.nr_raport,
          onClick: handleDownloadNrcd,
        },
      ]}
    />
  );
}

export default ReturningProductsReportsActionButton;
